import React, { useMemo } from 'react';
import { FaFileAlt, FaImage, FaMapMarkerAlt, FaFilePdf } from 'react-icons/fa';
import '../styles/send-template.css';

const replacePlaceholders = (text = '', values = []) => {
  if (!text) return '';
  let output = text;
  values.forEach((value, index) => {
    const token = new RegExp(`{{${index + 1}}}`, 'g');
    output = output.replace(token, value || `{{${index + 1}}}`);
  });
  return output.replace(/\n/g, '<br />');
};

const TemplatePreview = ({
  headerType = 'NONE',
  headerText = '',
  headerValues = [],
  bodyText = '',
  bodyValues = [],
  footerText = '',
  buttons = [],
  mediaPreviewUrl = '',
}) => {
  const headerContent = useMemo(() => replacePlaceholders(headerText, headerValues), [headerText, headerValues]);
  const bodyContent = useMemo(() => replacePlaceholders(bodyText, bodyValues), [bodyText, bodyValues]);

  const renderHeader = () => {
    switch (headerType) {
      case 'IMAGE':
        return mediaPreviewUrl ? (
          <img className="chat-header-image" src={mediaPreviewUrl} alt="Header" />
        ) : (
          <FaImage className="chat-header-icon" style={{ marginLeft: '10px', fontSize: '10rem', color: '#8696a0' }} />
        );
      case 'VIDEO':
        return mediaPreviewUrl ? (
          <video className="chat-header-image" src={mediaPreviewUrl} controls style={{ maxWidth: '100%', borderRadius: '8px' }} />
        ) : (
          <FaImage className="chat-header-icon" style={{ marginLeft: '10px', fontSize: '10rem', color: '#8696a0' }} />
        );
      case 'DOCUMENT':
        return (
          <FaFilePdf className="chat-header-icon" style={{ marginLeft: '10px', fontSize: '10rem', color: '#8696a0' }} />
        );
      case 'LOCATION':
        return (
          <FaMapMarkerAlt className="chat-header-icon" style={{ marginLeft: '10px', fontSize: '10rem', color: '#8696a0' }} />
        );
      case 'TEXT':
        return headerContent ? (
          <div className="chat-headermod" dangerouslySetInnerHTML={{ __html: headerContent }} />
        ) : null;
      default:
        return null;
    }
  };

  const buttonText = buttons?.length > 0 ? buttons.map(b => b.text).join(', ') : '';

  return (
    <div className="chadiv1">
      <div className="chatboxmod">
        <div className="chat-headermod">{renderHeader()}</div>
        {bodyContent ? (
          <div className="chat-bodymod" dangerouslySetInnerHTML={{ __html: bodyContent }} />
        ) : null}
        {footerText ? <div className="chat-footermod">{footerText}</div> : null}
      </div>
      {buttonText && (
        <div className="chat-buttons12mod">
          <button className="chat-button1mod">{buttonText}</button>
        </div>
      )}
    </div>
  );
};

export default TemplatePreview;
